<template>
  <div class="shop-content" ref="element">
    <div class="header-box" ref="header">
      <div class="name">采购单号：<p>{{procurementOrderNo}}</p> <a class="copy-number" data-clipboard-action="copy" :data-clipboard-text="procurementOrderNo" @click="copy">复制</a></div>
      <div class="c999 status" v-if="procurementStatus==1">未签约</div>
      <div class="corange status" v-if="procurementStatus==2">已签约</div>
      <div class="cgreen status" v-if="procurementStatus==3">已完成</div>
      <div class="cred status" v-if="procurementStatus==4">已关闭</div>
    </div>
    <div class="logistics_wrap">
      <div class="form_wrap">
        <div class="label">物流公司</div>
        <div :class="{'logistivs_value':true,active:logistivsValue}" @click="selectLogistivs">{{ logistivsValue?logistivsValue.label:'请选择' }}</div>
        <div class="label">物流单号</div>
        <input type="text" placeholder="请输入" v-model="logisticsNo">
      </div>
      <div class="submit" @click="uploadLogisticsInfo">提交</div>
    </div>

    <vue-pickers :data="pickData" @cancel="cancel" @confirm="confirm" :showToolbar="true" :maskClick="true" :visible.sync="pickerVisible"></vue-pickers>

    <div class="wrap-login" v-if="loginShow">
      <div class="login-con">
        <div class="close" @click="loginShow=false"></div>
        <div class="login">
          <div class="login-top">
            <p>签约授权</p>
            <div>
              <input type="text" :disabled="true" placeholder="输入手机号" v-model="mobileTxt">
            </div>
            <div class="yzm">
              <input type="text" placeholder="输入验证码" maxLength="6" v-model="loginForm.verificationCode">
              <button class="place" :disabled="disabled" @click="getCode">{{ttext}}</button>
            </div>
            <!-- <div class="operationRule">
              <img src="https://res.ponhu.cn/redbookRecovery/checkboxSelect.png?a=qweqwe" alt="" v-if="knowType" @click="knowType = !knowType">
              <img src="https://res.ponhu.cn/redbookRecovery/checkboxUncheckedImage2.png?a=qweqwe" alt="" v-else @click="knowType = !knowType">
              我已阅读并同意<a href="https://m.ponhu.cn/Ht/privacy.html" hover-class="none">《胖虎奢侈品采购协议》</a>
            </div> -->
          </div>
          <div class="init" @click="login">确认</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vuePickers from 'vue-pickers'
import ClipboardJS from 'clipboard';
import { signContractList, logisticsList, uploadLogisticsInfo } from '@/api/order'
import wxapi from '@/utils/wxApi'
import { sendVCode, quicklyLogin } from '@/api/login'
import { validatMobile } from '@/utils/validate'

export default {
  components: { vuePickers },
  data () {
    return {

      pickerVisible: false,
      pickData: [],
      logistivsValue: '',
      logisticsNo: '',
      procurementId: '',
      inventoryCode: [],


      loginForm: {
        mobile: '',
        verificationCode: '',
        channel: 2,
        userSource: 21,
        version: ''
      },
      knowType: false,
      ttext: '获取验证码',
      disabled: false,
      loginShow: false,
      mobileTxt: '',
      isUpload: false,
    }
  },

  computed: {
    token () {
      return this.$store.getters.token
    }
  },
  created () {
    // this.orderid = this.$route.params.oid
    // wxapi.wxRegister(this.wxRegCallback)
    console.log(this.$route.query);
    this.procurementOrderNo = this.$route.query.procurementOrderNo
    this.procurementStatus = this.$route.query.procurementStatus
    this.procurementId = Number(this.$route.query.procurementId)
    this.inventoryCode = JSON.parse(JSON.stringify(this.$route.query.inventoryCode))
    if (!Array.isArray(this.inventoryCode)) {
      this.inventoryCode = [this.inventoryCode]
    }
    console.log(this.inventoryCode)
    this.logisticsList()
    this.signContractList()
  },
  mounted () {

  },


  methods: {
    signContractList () {
      signContractList({
        procurementNo: this.procurementOrderNo,
        // pageIndex: 0,
        // pageSize: 0,
        // status: 0
      }).then(res => {
        if (res) {
          console.log(res);
          this.loginForm.mobile = res.supplierPhone;
          var reg = /^(\d{3})\d{4}(\d{4})$/;
          this.mobileTxt = res.supplierPhone.replace(reg, "$1****$2");
        } else {
          this.$toast('没有此采购单信息');
        }
      }).catch(err => {
        console.log(err)
        this.$toast(err)
      })
    },
    // 物流公司
    logisticsList () {
      logisticsList().then(res => {
        if (res) {
          console.log(res);
          let tdata = []
          res.forEach(item => {
            tdata.push({
              label: item.value,
              value: item.code
            })
          });
          this.pickData = [tdata]
        } else {
          //this.$toast('');
        }
      }).catch(err => {
        console.log(err)
        this.$toast(err)
      })
    },
    //复制微信
    copy () {
      let _this = this
      let clipboard = new ClipboardJS('.copy-number');
      clipboard.on('success', function (e) {
        _this.$toast('已经复制到粘贴板！');
        clipboard.destroy();
        e.clearSelection();
      })
      clipboard.on('error', function () {
        _this.$toast('该设备不支持自动复制');
      })
    },

    selectLogistivs () {
      this.pickerVisible = true
    },

    cancel () {
      console.log('cancel')
      // this.result = 'click cancel result: null'
    },
    confirm (res) {
      // this.result = JSON.stringify(res)
      console.log(res)
      this.logistivsValue = res[0]
    },
    uploadLogisticsInfo () {
      console.log(this.token);
      if (!this.token) {
        this.loginShow = true;
        this.loginForm.verificationCode = '';
        return false
      }
      if (this.isUpload) {
        return false
      }
      this.isUpload = true
      uploadLogisticsInfo({
        inventoryCode: this.inventoryCode,
        logisticsCompany: this.logistivsValue.value,
        logisticsNo: this.logisticsNo,
        procurementId: this.procurementId,
        userName: this.$store.getters.userPhone,
      }).then(res => {
        // if (res) {
        console.log(res);
        this.$toast('提交成功~')
        this.isUpload = false
        // this.$router.go(-1);//返回上一层
        this.$router.push({
          // name: 'online_purchase_logistics',
          path: '/online/purchase/contract/' + this.procurementOrderNo
        })
        // } else {
        //this.$toast('');
        // }
      }).catch(err => {
        console.log(err)
        this.isUpload = false
        this.$toast(err)
      })
    },

    //获取验证码
    getCode () {
      if (!validatMobile(this.loginForm.mobile)) {
        this.$toast('请输入正确的手机号')
        return
      }
      let that = this
      let t = 60
      that.ttext = t + '秒后重试'
      that.disabled = true
      var timer = setInterval(function () {
        t--
        if (t > 0) {
          that.ttext = t + '秒后重试'
          that.disabled = true
        } else {
          that.disabled = false
          that.ttext = '获取验证码'
          clearInterval(timer)
        }
      }, 1000)
      sendVCode({ mobile: this.loginForm.mobile }).then(res => {
        console.log(res)
      }).catch(error => {
        this.$toast(error)
      })
    },
    // 登录
    login () {
      if (!validatMobile(this.loginForm.mobile)) {
        this.$toast('请输入正确的手机号')
        return
      }
      if (!this.loginForm.verificationCode) {
        this.$toast('请输入短信验证码')
        return
      }
      quicklyLogin(this.loginForm).then(res => {
        this.loginShow = false
        this.$store.dispatch('LoginByUser', res.userToken)
        this.$store.dispatch('LoginByUserPhone', res.phone)
        this.loginForm.verificationCode = '';
      }).catch(error => {
        console.log(error)
        this.$toast(error)
      })
    },
  }

}
</script>

<style lang="less" scoped>
.shop-content {
  background-color: #ffffff;
  height: 100vh;
}
.header-box {
  display: flex;
  justify-content: space-between;
  // position: fixed;
  // top: 0;
  // left: 0;
  width: 100%;
  box-sizing: border-box;
  padding: 0rem 0.24rem;
  // height: 0.6rem;
  line-height: 0.6rem;
  border-bottom: 1px solid #e6e7e9;
  background-color: #ffffff;
  height: 1.1rem;
  align-items: center;
  .name {
    font-size: 0.36rem;
    color: #282828;
    display: flex;
    align-items: center;
    p {
      margin: 0;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 55%;
    }
  }
  .status {
    font-size: 0.36rem;
    font-weight: 500;
  }
  .copy-number {
    width: 1rem;
    height: 24px;
    font-size: 0.24rem;
    line-height: 23px;
    text-align: center;
    border-radius: 24px;
    padding: 0.06rem 0.1rem 0;
    margin-left: 0.2rem;
    display: inline-block;
    border: 1px solid rgba(0, 0, 0, 0.2);
  }
}

.logistics_wrap {
  width: 80%;
  margin: 0 auto;
  padding-top: 2rem;
  .form_wrap {
    padding-bottom: 2rem;
    .label {
      font-size: 0.36rem;
      color: #282828;
      margin-bottom: 0.3rem;
    }
    .logistivs_value {
      width: 100%;
      box-sizing: border-box;
      border: 1px solid #989898;
      padding: 0 0.2rem;
      font-size: 0.36rem;
      color: #282828;
      line-height: 1rem;
      margin-bottom: 0.6rem;
      color: #999999;
      border-radius: 0.2rem;
      &.active {
        color: #282828;
      }
    }
    input {
      font-size: 0.36rem;
      color: #282828;
      line-height: 1rem;
      width: 100%;
      box-sizing: border-box;
      border-radius: 0.2rem;
      padding: 0 0.2rem;
      border: 1px solid #989898;
    }
  }
  .submit {
    width: 100%;
    text-align: center;
    margin: 0 auto;
    background: #ffd133;
    color: #282828;
    font-size: 0.36rem;
    line-height: 1rem;
    border-radius: 0.5rem;
  }
}

.wrap-login {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.7);
  .login-con {
    width: 582px;
    height: 638px;
    position: absolute;
    top: 19.5%;
    left: 50%;
    transform: translateX(-50%);
    .close {
      width: 57px;
      height: 81px;
      background: url("../../../assets/img/close.png");
      background-size: 100%;
      position: absolute;
      right: 0;
      top: 0;
    }
    .login {
      width: 582px;
      height: 557px;
      background: white;
      border-radius: 12px;
      position: absolute;
      bottom: 0;
      left: 0;
      .login-top {
        width: 513px;
        height: 316px;
        margin: 44px auto;
        p {
          font-size: 32px;
          font-weight: 700;
          color: #333333;
          line-height: 40px;
          text-align: center;
        }
        p:nth-child(2) {
          font-size: 28px;
          font-weight: 400;
          color: #282828;
          line-height: 40px;
          margin-top: 19px;
        }
        input {
          width: 490px;
          height: 89px;
          text-align: left;
          background: #f7f7f7;
          font-size: 0.28rem;
          font-weight: 400;
          color: #282828;
          outline: none;
          border: none;
          padding: 0 0 0 0.25rem;
          border-radius: 0.12rem;
          position: absolute;
          top: 130px;
        }
        .yzm {
          border-radius: 0.12rem;
          color: #282828;
          font-weight: 400;
          outline: none;
          border: none;
          position: absolute;
          input {
            width: 280px;
            height: 89px;
            border-radius: 0.12rem;
            padding: 0 0 0 0.25rem;
            margin-top: 0;
          }
          .place {
            width: 196px;
            height: 89px;
            padding: 0;
            border-radius: 0.12rem;
            border: 1px solid #ffd133;
            color: #ffd133;
            background-color: #ffffff;
            float: right;
            text-align: center;
            line-height: 89px;
            font-size: 28px;
            position: absolute;
            left: 310px;
            top: 130px;
          }
        }
      }
      .init {
        width: 100%;
        height: 88px;
        background: #ffd133;
        color: #282828;
        font-size: 28px;
        line-height: 88px;
        color: rgba(40, 40, 40, 1);
        text-align: center;
        position: absolute;
        bottom: 0;
        border-bottom-left-radius: 0.12rem;
        border-bottom-right-radius: 0.12rem;
      }
    }
  }
}
</style>


